var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right-arrow (1) 1",
    clipPath: "url(#clip0_186_1284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3575 2.65076C13.3338 1.62712 11.6741 1.62712 10.6505 2.65076C9.62686 3.6744 9.62686 5.33407 10.6505 6.35771L14.2964 10.0047H2.50361C1.12293 10.0047 0.00366211 11.1239 0.00366211 12.5046C0.00366211 13.8853 1.12293 15.0046 2.50361 15.0046H14.2964L10.6505 18.6505C9.62686 19.6741 9.62686 21.3338 10.6505 22.3574C11.6741 23.3811 13.3338 23.3811 14.3575 22.3574L23.8573 12.8576C24.0525 12.6624 24.0525 12.3459 23.8573 12.1506L14.3575 2.65076Z",
    fill: "#2EBB49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_1284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.00366211 0.504089)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.993870259f64dd495c01468e02cc8319.svg";
export { ForwardRef as ReactComponent };